import type { Incoterms } from "adl-gen/ferovinum/app/db";
import { incotermsToString } from "utils/conversion-utils";
import { StickyNote, type StickyNoteAction } from "../sticky-note";

export interface IncotermsStickyNoteProps {
  incoterms: Incoterms;
  action?: StickyNoteAction;
}
export const IncotermsStickyNote = ({
  incoterms,
  action,
}: IncotermsStickyNoteProps) => {
  return (
    <StickyNote
      title="Incoterms"
      line1={incotermsToString(incoterms)}
      action={action}
    />
  );
};
